import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { Col, Grid, Row } from 'react-bootstrap';
import UserEditForm from './user-edit-form';
import BackLink from '../../../common/back-link/index';
import PageTitle from '../../../common/page-title/index';
import { doPseudoLogin, getUserEdit } from '../../../../actions/users';
import Can from '../../../common/guards/can';
import Button from '../../../common/button';
import { isAdminLoggedIn } from '../../../../utils/tokenUtils';

import './styles.css';

class EditUser extends Component {
  onPseudoLogin = (user) => {
    const redirectUrl = isAdminLoggedIn() ? '/admin/audit/submissions/next' : 'team';
    const isSuperAdmin = user.attributes['user-group-id'] === 1;
    const isYourself = user.attributes.email === this.props.currentUser.attributes.email;

    if (isSuperAdmin || isYourself) {
      return false;
    }

    this.props.dispatch(doPseudoLogin(this.id))
      .then(() => {
        setTimeout(() => {
          localStorage.setItem('admin-pseudo-login-started-from', window.location.href);
          window.location.href = redirectUrl;
        }, 2000);
      });

    return true;
  };

  componentWillMount() {
    const { dispatch } = this.props;
    this.id = +this.props.match.params.id;

    if (this.id) {
      dispatch(getUserEdit(this.id));
    } else {
      dispatch(actions.reset('deep.admin_user.edit'));
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.admin_user.edit'));
    dispatch({ type: 'CLEAR_EDIT_USER' });
  }

  render() {
    const { user, currentUser } = this.props;
    const isSuperAdmin = user.attributes['user-group-id'] === 1;
    const isYourself = user.attributes.email === currentUser.attributes.email;

    return (
      <Grid bsClass="container" fluid className="users">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/users"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="header">
              <PageTitle>
                Add/Edit user
              </PageTitle>
              <Can action={'rep-pseudo-login-read,rep-pseudo-login-write,pseudo-login-read,pseudo-login-write'} subjectClass="web_app">
                <Button
                  className="red-ghost-btn pseudo-login"
                  onClick={() => this.onPseudoLogin(user)}
                  hidden={isSuperAdmin || isYourself}
                >
                  Pseudo log in
                </Button>
              </Can>
            </div>
          </Col>
        </Row>
        {
          user && <UserEditForm edit={!!this.id} id={this.id} user={user}/>
        }
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  user: state.users.user,
  currentUser: state.viewConfig.profile,
  fetched: state.users.fetched,
  fetching: state.users.fetching,
});

export default connect(mapStateToProps)(EditUser);



// WEBPACK FOOTER //
// ./src/components/admin/users/edit/edit.jsx